
const Const = {
    LOCALIZATION_GET_LOGIN_LOCALIZATION_REQUEST: 'LOCALIZATION_GET_LOGIN_LOCALIZATION_REQUEST',
    LOCALIZATION_GET_LOCALIZATION_REQUEST: 'LOCALIZATION_GET_LOCALIZATION_REQUEST',
    LOCALIZATION_GET_LOCALIZATION_REQUEST_START: 'LOCALIZATION_GET_LOCALIZATION_REQUEST_START',
};

export default Const;